var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coming-soon-banner",style:(_vm.translateX)},_vm._l((_vm.bannerText),function(text,index){return _c('span',{key:index,staticClass:"text has-text-weight-semibold"},[_vm._v(_vm._s(text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }